import Immutable from 'seamless-immutable';
// ---- external imports ----

import { TURN_PHASES } from '~/lib/constants';
// ---- internal imports ----

import * as types from './actionTypes';
// ---- local imports ----

const initialState = Immutable({
	num: 1,
	isNextTurnLoading: false,
	phase: TURN_PHASES.PREPARATION,
	date: `1 Jan ${new Date().getFullYear().toString().slice(-2)}`,
	msg: 'Receive Customers',
	saveCheckpointAfterTurnLoaded: false,
	hasPurchasedStockThisTurn: false,
	shallMissoutOnCustomers: false,
	missoutScenario: null,
});

export default function reduce(state = initialState, action = {}) {
	switch (action.type) {
	case types.TURN_FETCHING_NEXT:
		return state.merge({
			isNextTurnLoading: action.isNextTurnLoading
		});
	case types.TURN_FETCHED_NEXT:
		return state.merge({
			...action.turn,
			saveCheckpointAfterTurnLoaded: state.saveCheckpointAfterTurnLoaded,
		});
	case types.TURN_STATUS_UPDATED:
		return state.merge({
			...action.turn,
			saveCheckpointAfterTurnLoaded: state.saveCheckpointAfterTurnLoaded,
		});
	case types.TURN_UPDATE_SAVE_CHECKPOINT_AFTER_FETCH:
		return state.merge({
			saveCheckpointAfterTurnLoaded: action.save
		});
	case types.TURN_HAS_PURCHASED_STOCK_THIS_TURN:
		return state.merge({
			hasPurchasedStockThisTurn: action.hasPurchasedStockThisTurn,
		});
	case types.TURN_SHALL_MISSOUT_ON_CUSTOMERS:
		return state.merge({
			shallMissoutOnCustomers: action.shallMissoutOnCustomers,
			missoutScenario: action.missoutScenario,
		});
	default:
		return state;
	}
}
